import classNames from "classnames";
import { SvgMiscReturnArrow } from "@ugitgud/legos/ui/icon/SVG/MiscReturnArrow";
import TwitchEmbed from "./TwitchEmbed";

export function StreamContainer({
  className,
  streamImage,
  streamName,
  streamTitle,
  streamChannel,
  handleClick,
}: {
  className?: string;
  streamName: string;
  streamImage: string;
  streamTitle: string;
  streamChannel: string;
  handleClick: () => void;
}) {
  return (
    <div className={classNames(className)}>
      <div onClick={handleClick} className="stream-embed-back-button">
        Back to stream list
        <SvgMiscReturnArrow className="stream-embed-back-button-icon"></SvgMiscReturnArrow>
      </div>
      <div className="stream-embed-container">
        <div className="stream-embed-title-container">
          <img className="stream-embed-profile-image" src={streamImage}></img>
          <div className="stream-embed-title-text">
            <div className="stream-embed-title">{streamName}</div>
            <div className="stream-embed-description"> {streamTitle}</div>
          </div>
        </div>
        <TwitchEmbed channel={streamChannel} />
      </div>
    </div>
  );
}
